<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Ventas</h3>
      </div>
      <div class="table-responsive">
        <table>
          <thead>
            <tr>
              <th># Cartilla</th>
              <th>Fecha</th>
              <th>Supervisor</th>
              <th>Día de cobro</th>
              <th>Total</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="venta in ventas" :key="venta.numero_documento">
              <td>
                <button
                  type="button"
                  @click="verVenta(venta)"
                  class="btn-info btn--text"
                >
                  {{ venta.numero_documento }}
                </button>
              </td>
              <td>
                {{ venta.fecha }}
              </td>
              <td>
                {{ venta.nombre_supervisor }}
              </td>
              <td>
                {{ venta.descripcion_dia_cobro }}
              </td>
              <td>
                {{ moneyFormat(venta.venta_total) }}
              </td>
              <td>
                <button
                  type="button"
                  @click="verComentarios(venta)"
                  class="btn-warning btn--text"
                >
                  <i class="fa fa-comments"></i><span>Comentarios</span>
                </button>
              </td>
            </tr>
            <tr v-show="ventas.length == 0">
              <td colspan="5">
                <strong>No se ha encontrado ventas.</strong>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="modal-buttons">
      <button type="button" @click="cerrar" class="btn-danger btn--text">
        <i class="fa fa-times"></i><span>Cerrar</span>
      </button>
    </div>
    <modal
      name="comentariosVenta"
      height="auto"
      width="60%"
      scrollable
      reset
      adaptive
      resizable
    >
      <comentarios-venta
        @cerrar="$modal.hide('comentariosVenta')"
        :ventaId="currentVentaId"
      ></comentarios-venta>
    </modal>
  </div>
</template>

<script>
import ComentariosVenta from "../logistica/pedidos/ComentariosVenta.vue";
export default {
  components: {
    ComentariosVenta,
  },
  props: {
    ventas: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  data: function () {
    return {
      currentVentaId: "",
      moneyFormat: moneyFormat
    };
  },
  methods: {
    verComentarios: function (venta) {
      this.currentVentaId = venta.id;
      this.$modal.show("comentariosVenta");
    },
    verVenta: function (venta) {
      window.open(url + "/logistica/pedidos/" + venta.id + "/edit", "_blank");
    },
    cerrar: function () {
      this.$emit("cerrar");
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/general/VentasDashboard.vue